import type { ReactNode } from "react";
import { Notice } from "@/components/Notice";
import { useEquipmentVisible } from "@/features/equipment/components/useEquipmentVisible";

export function EquipmentGate({ children }: { children: ReactNode }) {
  return useEquipmentVisible() ? <>{children}</> : <Notice tone="info">Equipment ordering isn't available yet.</Notice>;
}
